import React, { createContext, useContext, useMemo } from "react";
import PropTypes from "prop-types";
//Limitless imports
import { useNavigationHook } from "./NavigationHook";
// Set the default state values for each context
export const NavigationContext = /*#__PURE__*/createContext({});
export const NavigationContextProvider = ({
  children
}) => {
  const nav = useNavigationHook();
  const navigationContext = useMemo(() => ({
    ...nav
  }), [nav.isNavigationExpanded, nav.isLargeScreen, nav.breadcrumb, nav.navItems]);
  return /*#__PURE__*/React.createElement(NavigationContext.Provider, {
    value: navigationContext
  }, children);
};
export const useNavigation = () => {
  return useContext(NavigationContext);
};
NavigationContextProvider.propTypes = {
  children: PropTypes.node.isRequired
};